(function () {
    angular.module('tmx-app').directive('tmxFingerPrint', tmxFingerPrint);

    function tmxFingerPrint() {
        var directive = {};
        directive.scope = {
            name: '@',
            label: '@',
            value: '=',
            form: '=',
            required: '@',
            onChange: '&',
            onImageClick: '&',
            dynamicField: '=',// only for dynamic form, ignore it and functions in which it occurs
            dynamicShow: '=',// only for dynamic form, ignore it and functions in which it occurs
            disabled: '=',
            attachment: '=',
        },
        directive.restrict = 'E',
        directive.templateUrl = 'common/directives/tmxFingerPrint/tmxFingerPrint.html',

        directive.controller = ["$scope", "$mdDialog", "tmxUtility","TmxDialogService", fingerPrintCtrl];
        directive.controllerAs = "fingerPrintCtrl";
        return directive;
    }

    function fingerPrintCtrl($scope, $mdDialog, tmxUtility,DialogService) {
        if (!angular.isDefined($scope.disabled)) {
            $scope.disabled = false;
        }
        var exists = tmxUtility.exists;
        var fileInputCtrl = this;
        fileInputCtrl.scope = $scope;
        if (!exists(fileInputCtrl.scope.value)) {
            fileInputCtrl.scope.value = '';
        }

        function updateIsChecked(newVal, oldVal) {
            if (newVal != oldVal) {
                $scope.isChecked = newVal;
                $scope.onchange();
            }
        }
        function shouldBeChecked() {
            return exists($scope.value) && $scope.value.length > 0 || exists($scope.fileURL);
        }

        $scope.isChecked = shouldBeChecked();
        if ($scope.attachment) {
            $scope.value = $scope.attachment;
        }
        $scope.$watch(shouldBeChecked, updateIsChecked);

        $scope.onFingerprintClick = function () {
            $mdDialog.show({
                controller: 'scanFingerPrintController',
                templateUrl: 'common/directives/tmxFingerPrint/scanFingerPrintDialog.html',
                parent: angular.element(document.body),
                locals: {
                },
                clickOutsideToClose: true
            }).then(function (dialogResult) {
                if (tmxUtility.exists(dialogResult)) {
                    $scope.value = dialogResult;
                    $scope.attachment = dialogResult;
                }
            });
        }

        $scope.onchange = function () {
            fileInputCtrl.scope.onChange({ value: fileInputCtrl.scope.value, scope: fileInputCtrl.scope });
        }

        $scope.cancel = function(){
            let title ="Confirm";
            let message ="Are you sure you want to delete?"
            DialogService.showConfirmDialog(title,message,function(){
                delete $scope.file;
                delete $scope.attachment;
                $scope.value = "";
            });
        }

    }
})();